import React from 'react';
import './AboutUs.scss';
import Footer from '../landing/landing-comp/Footer';
import Header from '../landing/landing-comp/Header';

const AboutUs = () => {
  return (
    <>
    <Header />
    <section className="about-section">
      <div className="container">
        <div className="header">
          <h2 className="title">About us</h2>
        </div>
        <p className="content-paragraph">
          FNOTrader.com is a one-stop platform for traders in futures and options (FNO). 
          This platform allows traders to analyze the entire FNO space in real time and 
          help make and execute the right decisions through respective broker APIs.
        </p>
        <p className="content-paragraph">
          Our Platform helps its users to perform analysis and buy/sell orders in a 
          single UI framework without the hassle of switching between multiple broker 
          terminals for placing orders.
        </p>
        <p className="content-paragraph">
          It is built/operated by professional traders having rich experience in the 
          Stock Market. They have brought together their expertise and experience to 
          provide an interface for its users which is simple, fast, reliable, robust, 
          and scalable at the same time.
        </p>
      </div>
    </section>
    <Footer />
    </>
  );
};

export default AboutUs;